import { render } from "./VlogDetail.vue?vue&type=template&id=203b8151"
import script from "./VlogDetail.vue?vue&type=script&lang=js"
export * from "./VlogDetail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__